var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRecycle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "recycle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1680 0v6851H0V0h1680z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "recycle_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.49 4.033a14.34 14.34 0 0120.194.252l.316.32.316-.32A14.33 14.33 0 0135.54 0c3.7 0 7.402 1.428 10.225 4.285l.253.262c5.392 5.732 5.308 14.801-.253 20.428l-.316.32.016.015L25.015 46 25 45.984l-.016.016L4.535 25.31l.016-.015-.316-.32c-5.647-5.713-5.647-14.976 0-20.69zm31.05 1.606a8.777 8.777 0 00-6.283 2.633L12.417 25.31l12.567 12.715 16.84-17.038a8.986 8.986 0 002.603-6.357c0-2.402-.925-4.66-2.603-6.358A8.777 8.777 0 0035.54 5.64z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#recycle_svg__a)",
    transform: "translate(-366 -2548)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#recycle_svg__b)",
    transform: "translate(366 2548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v46H0V0z"
  })))));
}

export default SvgRecycle;